import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetClassNames(club) {

  var url = "/class_app/" + club + "/admin/all_class_names";

  return FetchGetDataWithAuthNEW(url);
}

